SEARCH_DEBOUNCE_INTERVAL  = 350
LOAD_ON_SCROLL_FRACTION   = 0.8

remainingPages = require 'utils/remaining-pages'

App.CategoriesController = Em.Controller.extend
  notifier: Em.inject.service()
  env: Em.inject.service('environment')
  session: Em.inject.service('session')

  needs: [ 'category' ]

  categories: Em.computed.alias('model')
  currentCategory: Em.computed.alias('controllers.category.model')
  organization: Em.computed.alias('session.currentOrganization')

  restaurants: null
  allRestaurants: null
  restaurants: (->
    @get('allRestaurants').filterBy('organization.id', @get('organization.id'))
  ).property('allRestaurants', 'organization')

  publishIsLoading: false

  isDragEnabled: false

  canEditMenu: Em.computed.alias('session.accessRights.menuEdit')
  cantEditMenu: Em.computed.not('canEditMenu')

  showDragEnableControl: Em.computed.and('canEditMenu','isTouchDevice')

  smSortableDisabled: (->
    @get('cantEditMenu') || @get('showDragEnableControl') && !@get('isDragEnabled')
  ).property('canEditMenu', 'isDragEnabled','showDragEnableControl')

  isTouchDevice: (->
    window.ontouchstart != undefined
  ).property()

  showOrganizationSelector: Em.computed.alias('session.manyOrganizations')

  organizationWatcher: (->
    @transitionToRoute 'category', @get('rootCategories.firstObject.id')
  ).observes('organization')



  # ---
  # Обработка актуальности меню
  # ---
  menuChangedAtClient: null
  menuChangedAtServerBinding: 'organization.menu_changed_at'

  newConfiguratorAvailable:  Em.computed.alias('session.currentOrganization.features.new_configurator')

  currentTab: 'categoryTab'

  menuChangedAt: (->
    d = [
      @get('menuChangedAtClient')
      @get('menuChangedAtServer')
    ].filter (x) -> x

    _.max(d)
  ).property(
    'menuChangedAtServer',
    'menuChangedAtClient')

  isMenuActual: (->
    x = @get('organization.menu_published_at')
    y = @get('menuChangedAt')

    return true if (!x and !y)
    x > y
  ).property(
    'organization.menu_published_at',
    'menuChangedAt')

  mediator: Em.inject.service('mediator')

  onModelChanged: (type, model) ->
    if model in [ 'draft_dish', 'draft_category' ]
      @set('menuChangedAtClient', new Date())

  installMenuRevelanceHandler: ->
    @get('mediator').off('modelChanged', @, @onModelChanged)
    @get('mediator').on('modelChanged', @, @onModelChanged)


  rootCategoriesAllOrganizations: Em.computed.filterBy 'categories', 'is_root', true
  rootCategories: (->
    @get('rootCategoriesAllOrganizations').filterBy('organization.id', @get('organization.id'))
  ).property('rootCategoriesAllOrganizations', 'rootCategoriesAllOrganizations.@each.is_root', 'organization')

  flattenedCategories: (->
    currentCategory = @get('currentCategory')
    return unless currentCategory
    @get('rootCategoriesAllOrganizations').filter((category) => category.id != currentCategory.id).map((category) => @getCategories(category)).flat(1000)
  ).property('categories', 'rootCategories', 'currentCategory')

  getCategories: (category) ->
    currentCategory = @get('currentCategory')
    [category, category.get('draft_categories').filter((category) => category.id != currentCategory.id).map (c) => @getCategories(c)]


  categoriesSortOrder: [ 'menu_order' ]
  sortedCategories: Em.computed.sort('rootCategories', 'categoriesSortOrder')

  publishedAtTime: (->
    moment(@get('organization.menu_published_at')).format("HH:mm")
  ).property('organization.menu_published_at')

  publishedAtDate: (->
    moment(@get('organization.menu_published_at')).format("DD.MM.YYYY")
  ).property('organization.menu_published_at')

  publishedAt: (->
    if @get('organization.menu_published_at')?
      @get('env').translate('categories.published_at', {date: @get('publishedAtDate'), time: @get('publishedAtTime')})
    else
      @get('env').translate('categories.not_published')
  ).property('publishedAtDate', 'publishedAtTime', 'organization.menu_published_at')

  # ---
  # Поиск
  # ---

  searchQuery: ''
  page: 1
  pageCount: 1
  perPage: 10
  dishes: []

  isLoading:  false

  debouncedSearchQuery: null
  debouncedSearchQueryTimeout: null

  debounceSearchQuery: (->
    Em.run.cancel @get('debouncedSearchQueryTimeout')
    if Ember.isEmpty(@get('searchQuery'))
      @set('debouncedSearchQuery','')
      return
    @set('debouncedSearchQueryTimeout', Em.run.later @, ->
      @set('debouncedSearchQuery', @get('searchQuery'))
      @set('debouncedSearchQueryTimeout',null)
    , 2000)
  ).observes('searchQuery')

  # ---
  # Debounced-версия подгрузки
  # ---
  debouncedLoad: (->
    _.debounce(@loadDishes.bind(@), SEARCH_DEBOUNCE_INTERVAL,
      leading: true, trailing: true)
  ).property('animationDuration')

  # ---
  # Изменилась строка поиска
  # ---
  onQueryChanged: (->
    @set('page', 1)
    @set('dishes', [])
    return if Ember.isEmpty(@get('searchQuery'))
    @get('debouncedLoad')()
  ).observes('debouncedSearchQuery')

  showPopover: (->
    not Ember.isEmpty(@get('searchQuery')) and not Ember.isEmpty(@get('dishes'))
  ).property('searchQuery', 'dishes')

  # ---
  # Получает порцию блюд с текущим фильтром
  # ---
  fetchDishPortion: ->
    new Em.RSVP.Promise (resolve, reject) =>
      page         = @get('page')
      perPage      = @get('perPage')
      searchQuery  = @get('searchQuery')
      organization = @get('organization')

      query = {}
      query.search = searchQuery if not Em.isBlank(searchQuery)
      query.page      = page
      query.per_page  = perPage
      query.organization_id = organization.get('id')

      @set('isLoading', true)
      @set('processingRequests', @get('processingRequests') + 1)

      @get('store').find('dish', query)
        .then (dishes) =>
          @set('processingRequests', @get('processingRequests') - 1)

          meta = dishes.get('meta')
          @setProperties
            page: meta.page
            pageCount: meta.page_count

          resolve(dishes)
        .catch(reject)
        .finally =>
          @set('isLoading', false)

  # ---
  # Подгружает первую порцию
  # ---
  loadDishes: ->
    return if @get('isDestroyed') or @get('isDestroying')
    return if @get('isLoading')

    @fetchDishPortion().then (dishes) =>
      @set('dishes', dishes)

  # ---
  # Подгружает новую страницу
  # ---
  loadMoreDishes: ->
    return if Ember.isEmpty(@get('dishes'))
    return if @get('isDestroyed') or @get('isDestroying')
    return if @get('isLoading')

    return if @get('page') >= @get('pageCount')

    @incrementProperty('page')
    @fetchDishPortion().then (dishes) =>
      @get('dishes').pushObjects(dishes.get('content'))

# ---
# Обработчик скролла и подгрузка данных on-demand
# ---

  actions:
    reorderCategory: (category, target, layout, rerender) ->
      # блокируем, чтобы убрать мерцание
      # @get('categories').forEach (d) -> d.beginPropertyChanges()

      # пересчитываем индексы на клиенте
      # layout.forEach (pair) -> pair[1].set('menu_order', pair[0])

      category.reorder(target.get('id'))#.then =>
        # rerender()
        # Em.run.scheduleOnce 'afterRender', =>
          # @get('categories').forEach (d) -> d.endPropertyChanges()
      false

    addCategory: ->
      @transitionToRoute('categories.create')

    publishMenu: ->
      return if @get('publishIsLoading')

      @set('publishIsLoading', true)
      @get('organization').publish()
      .then (o) =>
        @get('notifier').pushNotification
          type: 'success'
          # todo i18n
          title: 'Опубликовано!'
          message: 'Меню опубликовано.'
          duration: 3000
      .catch (o) =>
        @get('notifier').pushNotification
          type: 'error'
          # todo i18n
          title: 'Ошибка!'
          message: 'Ошибка публикации меню.'
          duration: 3000
      .finally =>
        @set('publishIsLoading', false)
        @get('organization').reload()

    loadMore: ->
      @loadMoreDishes()
      false


    openDishModal: (dish) ->
      @set('dishes', [])
      @set('searchQuery', '')
      draftDish = @store.find('draft_dish', dish.get('id'))
      categoryId = dish.get('category.id') # Предполагая, что у блюда есть связь с категорией
      @transitionToRoute('category.dish', categoryId, dish.get('id')) if categoryId?
      false
